export class Trpdbmrgr {
    public V_No!: string;
    public V_Type!: string;
    public V_Date!: Date;
    public BillOrGR!: string;
    public BillOrGR_NO!: string;
    public Amt!: number;
    public SETT_AMT!: number;
    public TDS!: number;
    public NET_SETT_AMT!: number;
    public DED_AMT!: number;
    public DED_TYPE!: string;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: Date;
    public UPDATED_DATE!: Date;
    public IS_ACTIVE!: boolean;
}